import { CenterActivitiesTable } from './center-activities-table'
import { CenterAddresses } from './center-addresses'
import { CenterCostsStatus } from './center-costs-status'
import { CenterCulturalOutingsTable } from './center-cultural-outings-table'
import { CenterFinalCostsBalance } from './center-final-costs-balance'
import { CenterFrenchLeaderCostsTable } from './center-freanch-leader-costs-table'
import { CenterHostFamilyCostsTable } from './center-host-family-costs-table'
import { CenterLocalOrganizersCostsTable } from './center-local-organizers-costs-table'
import { CenterMiscellaneousCostsTable } from './center-miscellaneous-costs-table'
import { CenterOlPaymentsTable } from './center-ol-payments-table'
import { CenterProgramDocuments } from './center-program-documents'
import { CenterTeachingHallCostsTable } from './center-teaching-hall-costs-table'
import { CenterTeflCostsTable } from './center-tefl-costs-table'
import { CenterTotalCosts } from './center-total-costs'
import { CenterArrivalDepartureTransfersTable } from './center-transfers-table'

function CenterCosts() {
  return <div>CenterCosts</div>
}

CenterCosts.Status = CenterCostsStatus
CenterCosts.LocalOrganizers = CenterLocalOrganizersCostsTable
CenterCosts.HostFamily = CenterHostFamilyCostsTable
CenterCosts.Tefl = CenterTeflCostsTable
CenterCosts.TeachingHall = CenterTeachingHallCostsTable
CenterCosts.CulturalOutings = CenterCulturalOutingsTable
CenterCosts.ArrivalDepartureTransfers = CenterArrivalDepartureTransfersTable
CenterCosts.Activities = CenterActivitiesTable
CenterCosts.FrenchLeader = CenterFrenchLeaderCostsTable
CenterCosts.TotalCosts = CenterTotalCosts
CenterCosts.Miscellaneous = CenterMiscellaneousCostsTable
CenterCosts.OlPayments = CenterOlPaymentsTable
CenterCosts.FinalBalance = CenterFinalCostsBalance
CenterCosts.ProgramDocuments = CenterProgramDocuments
CenterCosts.Addresses = CenterAddresses

export { CenterCosts }
